<template>
  <a-tabs default-active-key="1">
    <a-tab-pane key="1">
      <span slot="tab">
        <a-icon type="flag" />
        Idiomas
      </span>
      <biodata-idioma-otros-estudios-idiomas :persona="persona"></biodata-idioma-otros-estudios-idiomas>
    </a-tab-pane>
    <a-tab-pane key="2">
      <span slot="tab">
        <a-icon type="book" />
        Cursos y certificaciones
      </span>
      <biodata-idioma-otros-estudios-no-formal :persona="persona"></biodata-idioma-otros-estudios-no-formal>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  export default {
    data () {
      return {}
    },
    props: ['persona']
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataIdiomaOtrosEstudios.vue